import React from 'react';
import { useTranslation } from 'react-i18next';
import { Controller } from 'react-hook-form';
import { CheckBox, Text } from '@oliasoft-open-source/react-ui-library';
import translations from 'src/internationalisation/translation-map.json';
import { convertToKebabCase } from 'client/common/utils/string-utils.ts';
import './style.css';
import { withErrorBoundary } from '@oliasoft-open-source/react-ui-library';

const RawCheckBoxList = ({ items, name, control, errors, disabled = false, onChange, testId = '', groupName = '' }) => {
  const { t } = useTranslation();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <>
          <Text error>{translations[errors[name]] ? t(errors[name]) : errors[name] || null}</Text>

          <div className="custom-grid">
            {items.map((item) => {
              const checkBoxListTestId = testId
                ? `${testId}-checkbox-${convertToKebabCase(groupName)}-${convertToKebabCase(item.name)}`
                : `raw-check-box-list-checkbox-${convertToKebabCase(item.name)}`;

              return (
                <React.Fragment key={item.id}>
                  <CheckBox
                    testId={checkBoxListTestId}
                    onChange={(e) => {
                      if (e.target.checked) {
                        field.onChange([...field.value, item.id]);
                      } else {
                        field.onChange(field.value.filter((value) => value !== item.id));
                      }
                      if (onChange) {
                        onChange(e);
                      }
                    }}
                    label={item.name}
                    value={item.id}
                    checked={field?.value ? field.value.includes(item.id) : false}
                    disabled={disabled}
                  />
                </React.Fragment>
              );
            })}
          </div>
        </>
      )}
    />
  );
};

export const CheckBoxList = withErrorBoundary(RawCheckBoxList);
